export default __webpack_public_path__ + "assets/0ff2dcae1e502d00dd92d47279062dcd.jpg";